import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../../Assets/0a-exporter";
import "./job-card.style.scss";
export default function JobCard({ data }) {
  let date = new Date();
  let cDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  const difference = (givenDate) => {
    if (!givenDate) return;
    let oldDate = `${givenDate[1]}/${givenDate[0]}/${givenDate[2]}`;

    let dateOne = new Date(`${oldDate}`);
    let dateTwo = new Date(`${cDate}`);
    let diff = dateTwo.getTime() - dateOne.getTime();
    diff = diff / (1000 * 3600 * 24);
    if (!isNaN(diff)) {
      return diff;
    } else {
      return "";
    }
  };

  return (
    <div className="job-card-main">
      <h5>{data?.jobTitle}</h5>
      <p className="duration">
        {!difference(data?.dateOpened?.split("-")?.reverse()) && difference(data?.dateOpened?.split("-")?.reverse()) !== 0 ? (
          ""
        ) : (
          <img src={Images.stopWatch} />
        )}
        {difference(data?.dateOpened?.split("-")?.reverse()) === 0?"Today": difference(data?.dateOpened?.split("-")?.reverse())}{" "}
        {!difference(data?.dateOpened?.split("-")?.reverse()) ? "" : `Days ago`}
      </p>
      <div className="job-info">
        <p className="above-line ">
          <img src={Images.blueLocation} alt="logo" /> {data?.location}
        </p>
        <div className="below-line">
          {!data?.custField1 ? (
            ""
          ) : (
            <p>
              {!data?.custField1 ? (
                ""
              ) : (
                <img src={Images.blueBook} alt="logo" />
              )}
              <span>{data?.custField1}</span>
            </p>
          )}
          <p>
            <img src={Images.groupLogo} alt="logo" />
            <span> 10-50 Staffs</span>
          </p>
          <p>
            <img src={Images.manWIthStars} alt="logo" />{" "}
            <span>+{data?.minWorkExp} Yrs exp</span>
          </p>
        </div>
      </div>
      <div className="jcm-bottom">
        {data.jobType ?<p>{data.jobType }</p>: <span/>}
        <Link to={`/user/description/${data?.jobId}`}>
          Apply now <img src={Images.orangeRightLogo} />
        </Link>
      </div>
    </div>
  );
}
